import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SchedulerDateRangeClient, SchedulerDateRangeDto } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class SchedulerDateRangeService {
    constructor(private readonly client: SchedulerDateRangeClient) {}

    async getAll(): Promise<SchedulerDateRangeDto[]> {
        return await lastValueFrom(this.client.schedulerDateRangeGetAll());
    }
}
